export default __webpack_public_path__ + "static/media/actions_domain.9ab35945.svg";